<template>
  <v-card outlined style="margin-bottom: 24px">
    <UpdateExamInfoForm :state="updateLeadDialog" :data="exam" @closeDialog="closeUpdate" @refresh="refresh" />
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class="text-uppercase align-self-center">Thông tin kỳ thi</h5>
      <v-btn
        text
        color="blue darken-4"
        class="pr-6 document-btn no-hover"
        plain
        @click="updateExam"
        style="height: 18px"
      >
        <v-icon left>mdi-playlist-edit</v-icon>
        Cập nhập
      </v-btn>
    </div>

    <v-row class="px-6 pb-6" no-gutters>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Địa điểm</p>
        <p class="my-0">{{ exam.location }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Loại thi</p>
        <p class="my-0">{{ exam.type | getType }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Tài liệu</p>
        <div>
          <v-chip v-for="(file, index) in exam.files" :key="index" @click="openFile(index)">
            {{ file.name }}
          </v-chip>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import UpdateExamInfoForm from './UpdateExamInfoForm.vue'

export default {
  props: {
    exam: Object
  },
  data() {
    return {
      updateLeadDialog: false,
      products: []
    }
  },
  methods: {
    updateExam() {
      this.updateLeadDialog = true
    },
    closeUpdate() {
      this.updateLeadDialog = false
    },
    refresh() {
      this.$emit('refresh')
    },
    openFile(index) {
      const files = this.exam.files

      const file = files[index]
      let fileUrl
      if (file.url) {
        fileUrl = file.url
      } else {
        fileUrl = URL.createObjectURL(file)
      }

      window.open(fileUrl, '_blank')
    }
  },
  filters: {
    getType: item => {
      switch (item) {
        case 'midTerm':
          return 'Thi giữa kỳ'
        case 'final':
          return 'Thi cuối kỳ'
        case 'extra':
          return 'Thi khác'
        default:
          return ''
      }
    }
  },
  components: { UpdateExamInfoForm }
}
</script>
